import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import BoxEditor from "./BoxEditor";
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import CheckBox from '../form/CheckBox';
import { isTrue } from '../../utils/other';
import { paramsSerializer, postData, sendRequest } from '../../utils/request';
import OptInSubscriberList from './lists/OptInSubscriberList';
import OptInSubscriberForm from './forms/OptInSubscriberForm';
import Select from '../form/Select';
import { saveComponent } from '../../utils/components';

class OptInSubscriberEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={"Hírlevél feliratkozások"}
                    footer={[
                        // <Button key="0" color="default" disabled={this.props.isLoading} onClick={ this.pristineForm }>
                        //     Új
                        // </Button>
                    ]}
                >
                    <OptInSubscriberList ref={(el) => this.list = el} {...this.props} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Feliratkozó"}
                    footer={[
                        // <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.saveForm }>
                        //     Mentés
                        // </Button>,
                        // <Button
                        //     key="1"
                        //     disabled={!this.props.values[this.props.componentConfig.idfield] || this.props.isLoading}
                        //     color="danger"
                        //     className="pull-left"
                        //     onClick={this.props.deleteForm}
                        // >
                        //     Törlés
                        // </Button>
                    ]}
                >
                    <Fragment>
                        <OptInSubscriberForm {...this.props} />
                        {
                            this.props.values.person_id &&
                            <SelectorGrid
                                ref={(subscriptions) => this.subscriptions = subscriptions}
                                component="OptInSubscriber"
                                filter={{field: "person_id", value: this.props.values.person_id}}
                                view={["optin.id", "person_id"]}
                                order={{field: "optin_id", direction: "ASC"}}
                                reqparams={{showdeleted: true}}
                                pageSize={20}
                                columns={{
                                    "optin.name": {header: 'OptIn', width: 2, sortable: true, filterable: true},
                                    "source.name": {header: 'OptIn forrása', width: 2, sortable: true, filterable: true},
                                    "created_at": {header: 'Feliratkozva', width: 2, sortable: true, filterable: true},
                                    "updated_at": {header: 'Frissítve', width: 2, sortable: true, filterable: true},
                                    "active": {header: 'Aktív', width: 2, sortable: true, className: "flagbox", filterable: true, 
                                        renderer: (value, row, rowIndex, props, parent) => <CheckBox
                                            name="active"
                                            checked={isTrue(value)}
                                            disabled={false}
                                            label={false}
                                            saveChanges={async (n, value, e) => {
                                                await postData({
                                                    action: "OptInForm." + (value == true ? "optinsignup" : "unsubscribe"),
                                                    data: {
                                                        optin: row.optin.id,
                                                        gdpr: 1,
                                                        person_id: row.person_id
                                                    }
                                                });
                                                this.subscriptions.refresh();
                                            }}
                                        />
                                    }
                                }}
                                addRow={
                                    <Select
                                        name="optin"
                                        component="OptIn"
                                        objectValue={true}
                                        valueKey={"id"}
                                        labelKey="name"
                                        storeType="local"
                                        placeholder="OptIn"
                                        saveChanges={async (field, value) => {
                                            await postData({
                                                action: "OptInForm.optinsignup",
                                                data: {
                                                    optin: value.id,
                                                    gdpr: 1,
                                                    person_id: this.props.values.person_id
                                                }
                                            });
                                            this.subscriptions.refresh();
                                        }}
                                        {...this.props.getFieldProps("authors")}
                                        label={false}
                                    />
                                }
                            />
                        }
                    </Fragment>
                </Editor>
            </Fragment>
        );
    }
}

export default createEditor({componentName: "OptInSubscriber", WrappedComponent: OptInSubscriberEditor, props: {view: "admin", showdeleted: true}});